import * as React from 'react'

import { Box, Divider, Text } from '@factorialco/deprecated-design-system'

import { OverflowContextProvider } from 'modules/core/lib/overflowContext'

import MinutesToText from 'modules/attendance/components/MinutesToText'

interface Props {
  minutes?: number
  title: string
  subtitle?: string
  small?: boolean
}

const TooltipHeader = ({ minutes, title, subtitle, small = false }: Props) => {
  const ref = React.useRef(null)

  return (
    <Box gap="s8">
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text color="grey000White" weight="semibold" size={small ? '200' : '300'} ellipsis>
          {title}
        </Text>

        <MinutesToText
          color="grey000White"
          value={minutes ?? 0}
          size={small ? '200' : '300'}
          weight="semibold"
        />
      </Box>
      <Divider backgroundColor="#FFFFFF" />

      {subtitle && (
        <OverflowContextProvider childrenRef={ref} value={title}>
          <Box width="full" textAlign="left">
            <Text size="200" weight="normal" color="grey000White" innerRef={ref}>
              {subtitle}
            </Text>
          </Box>
        </OverflowContextProvider>
      )}
    </Box>
  )
}

export default TooltipHeader
